import { render, staticRenderFns } from "./CompactEditTemplateRefComponent.vue?vue&type=template&id=565e8973&scoped=true&"
import script from "./CompactEditTemplateRefComponent.vue?vue&type=script&lang=js&"
export * from "./CompactEditTemplateRefComponent.vue?vue&type=script&lang=js&"
import style0 from "./CompactEditTemplateRefComponent.vue?vue&type=style&index=0&id=565e8973&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565e8973",
  null
  
)

export default component.exports